import {IResponseResourcePath} from '@toolify/server/src/services/ResourceService/types/resourcePath/IResponseResourcePath'
import {ResourceType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/ResourceType'
import {
  IResponseInstanceTypeByResourceType,
} from '@toolify/server/src/services/ResourceService/types/IResponseInstanceTypeByResourceType'

export function findResourceByResourceTypeInPath<T extends ResourceType>(responseResourcePath: IResponseResourcePath, resourceType: T): IResponseInstanceTypeByResourceType[T] {
  return responseResourcePath?.find(pathItem => {
    return pathItem?.resourceType === resourceType
  })?.resource as IResponseInstanceTypeByResourceType[T]
}

export function findResourceIdByResourceTypeInPath(responseResourcePath: IResponseResourcePath, resourceType: ResourceType): string | null {
  return responseResourcePath?.find(pathItem => pathItem?.resourceType === resourceType)?.resourceId ?? null
}
